// extracted by mini-css-extract-plugin
export default {"options":"AnswerOptions_options__trvCP","answer":"AnswerOptions_answer__BLq3Z","selected":"AnswerOptions_selected__mrZ9y"};